import { createFileRoute, redirect } from '@tanstack/react-router';
import { getDefaultTargetMonth } from '@/features/contract-and-cost/targetMonth';
export const Route = createFileRoute('/_staff/software/_layout/contract-and-cost/_contract-and-cost/payment/')({
  beforeLoad: () => {
    throw redirect({
      to: '/software/contract-and-cost/payment/$targetMonth',
      params: {
        targetMonth: getDefaultTargetMonth()
      }
    });
  }
});